export default __webpack_public_path__ + "static/cw2-5e87d3800156fb6f36c87bb9dd2bce5a.jpg";